module.exports = __webpack_public_path__ + "img/88009030000886.a98e5dbe.png";